exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.vermelho-global{\n\t \tbackground-color: #ef233c;\n}\n.vermelho-global:hover{\n\t \tbackground-color: #ef233c !important;\n\t\tcolor: white;\n    \t\tbox-shadow: 1px 1px 2px grey;\n}\n\n\n", ""]);

// exports
